import Disclaimer from '../../pages/disclaimers/Disclaimer.vue';
import Disclaimers from '../../pages/disclaimers/Disclaimers.vue';
import CreateDisclaimer from '../../pages/disclaimers/CreateDisclaimer.vue';
import EditDisclaimer from '../../pages/disclaimers/EditDisclaimer.vue';

/**
 * MLD-5970
 */
export default [
  {
    path: '/v2/admin/disclaimers',
    name: 'admin.disclaimers.index',
    component: Disclaimers,
    meta: {
      permission: 'can_edit_presentations',
    },
  },
  {
    path: '/v2/admin/disclaimers/create',
    name: 'admin.disclaimer.create',
    component: CreateDisclaimer,
    meta: {
      permission: 'can_edit_presentations',
    },
  },
  {
    path: '/v2/admin/disclaimers/:disclaimerID(\\d+)',
    component: Disclaimer,
    children: [
      {
        path: 'edit',
        name: 'admin.disclaimer.edit',
        component: EditDisclaimer,
        meta: {
          permission: 'can_edit_presentations',
        },
      },
    ],
  },
]
